import React, { memo } from 'react';

export const SmallIcon = memo(({ color = '#7d8a96', ...props }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="48"
            height="49"
            fill="none"
            viewBox="0 0 48 49"
            {...props}
        >
            <path
                fill={color}
                fillRule="evenodd"
                d="M16.93 14.5h14.14c1.614.006 2.924 1.316 2.93 2.93v14.14c-.006 1.614-1.316 2.924-2.93 2.93H16.93c-1.614-.006-2.924-1.316-2.93-2.93V17.43c.006-1.614 1.316-2.924 2.93-2.93zm14.08 2.99v14.02H16.99V17.49h14.02z"
                clipRule="evenodd"
            />
        </svg>
    );
});

export const VerticalIcon = memo(({ color = '#7d8a96', ...props }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="48"
            height="49"
            fill="none"
            viewBox="0 0 48 49"
            {...props}
        >
            <path
                fill={color}
                fillRule="evenodd"
                d="M34 9.43v30.14c-.006 1.614-1.316 2.924-2.93 2.93H16.93c-1.614-.006-2.924-1.316-2.93-2.93V9.43c.006-1.614 1.316-2.924 2.93-2.93h14.14c1.614.006 2.924 1.316 2.93 2.93zm-2.99 30.08H16.99V9.49h14.02v30.02z"
                clipRule="evenodd"
            />
        </svg>
    );
});

export const HorizontalIcon = memo(({ color = '#7d8a96', ...props }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="48"
            height="49"
            fill="none"
            viewBox="0 0 48 49"
            {...props}
        >
            <path
                fill={color}
                fillRule="evenodd"
                d="M9.43 14.5h30.14c1.614.006 2.924 1.316 2.93 2.93v14.14c-.006 1.614-1.316 2.924-2.93 2.93H9.43c-1.614-.006-2.924-1.316-2.93-2.93V17.43c.006-1.614 1.316-2.924 2.93-2.93zm30.08 2.99v14.02H9.49V17.49h30.02z"
                clipRule="evenodd"
            />
        </svg>
    );
});

export const BigIcon = memo(({ color = '#7d8a96', ...props }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="48"
            height="49"
            fill="none"
            viewBox="0 0 48 49"
            {...props}
        >
            <path
                fill={color}
                fillRule="evenodd"
                d="M8.93 6.5h30.14c1.614.006 2.924 1.316 2.93 2.93v30.14c-.006 1.614-1.316 2.924-2.93 2.93H8.93c-1.614-.006-2.924-1.316-2.93-2.93V9.43c.006-1.614 1.316-2.924 2.93-2.93zm30.08 2.99v30.02H8.99V9.49h30.02z"
                clipRule="evenodd"
            />
        </svg>
    );
});
